import React, { Component } from "react";
import { connect } from "react-redux";
import { loadMicroApp } from "qiankun";
import { GetQuery, checkWindowClosable, isNotDealDark } from "Pub/js/utils";
import platform from "Pub/js/platform";
const { setThemeClassName } = platform;
import './index.less';

class MicroApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            app: this.getAppState(),
            qiankunApp: null // 乾坤实例
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.visible !== this.props.visible) {
            if (this.registerEvents) {
                const visibleEvents = this.registerEvents['visibilitychange'];
                visibleEvents && setTimeout(() => { // 延迟执行，避免获取到的元素宽高不正确
                    visibleEvents.forEach(c => c({
                        visibilityState: nextProps.visible ? 'visible' : 'hidden',
                        isInsideTab: true // platform之前有提供这个给领域，搬过来，报表有用，具体啥用，不知道
                    }))
                })
            }
        }
        if (nextProps.theme && (nextProps.theme.type !== this.props.theme.type || nextProps.theme.color !== this.props.theme.color)) { // 主题变化
            this.setMicroTheme(nextProps.theme.type);
        }
    }
    componentDidMount() {
        // console.log('MicroApp-didmount', this.state.app);
        this.qiankunLoadApp();
    }
    componentWillUnmount() {
        // console.log('MicroApp-unmount', this.state.app);
        this.qiankunUnmountApp();
    }
    qiankunLoadApp(callback) {
        const { app } = this.state;
        const { onTabClose, updateTabName, tabKey, theme } = this.props;
        // 加载微应用
        const appKey = app.key;
        const appContainer = app.selector;
        const qiankunApp = loadMicroApp({
            name: app.name,
            entry: app.entry,
            container: appContainer,
            props: {
                // from: `主应用传参至微应用-${app.entry}`,
                runContext: { // 运行时上下文
                    isQiankun: true,
                    initialEntries: app.initialEntries,
                    appInfo: this.appInfo,
                    appKey,
                    tabKey,
                    appContainer
                },
                globalEvent: { // 全局事件
                    // callback 模拟addEventListener的回调
                    add: (type, callback) => {
                        if (!this.registerEvents) {
                            this.registerEvents = {};
                        }
                        if (!this.registerEvents[type]) {
                            this.registerEvents[type] = [];
                        }
                        this.registerEvents[type].push(callback);
                    },
                    remove: (type, callback) => {
                        if (this.registerEvents && this.registerEvents[type]) {
                            const index = this.registerEvents[type].findIndex(c => c === callback);
                            if (index !== -1) {
                                this.registerEvents[type].splice(index, 1);
                            }
                        }
                    },
                    emit: () => {}
                },
                globalApi: {
                    close: onTabClose,
                    reload: this.refresh.bind(this),
                    updateTitle: updateTabName
                }
            }
        }, {
            sandbox: {
                // strictStyleIsolation: true, // 这个开启之后子应用的click事件等失效
                experimentalStyleIsolation: true
            },
            getPublicPath: (path) => {
                return path; // entry地址
            },
            getTemplate: (tpl) => {
                return tpl; // html内容
            },
            fetch(url, ...args) {
                // console.log('qiankun-fetch', url);
                // if (url.includes('AppRegister/index.js')) {
                //     return new Promise(resolve => {
                //         window.fetch(url, ...args).then(res => {
                //             res.text().then(txt => { // index.js的文件内容
                //                 resolve({
                //                     async text() {
                //                         return txt;
                //                     }
                //                 })
                //             });
                //         })
                //     })
                // }

                if (url.includes('.html')) {
                    return new Promise(resolve => {
                        window.fetch(url, ...args).then(res => {
                            res.text().then(txt => {
                                // 追加platform给微应用提供的js
                                if (/data-name="standard_template"/.test(txt) && !/<script.*platform\/api-min\/index.js.*<\/script>/.test(txt)) {
                                    const platformApiMatched = txt.match(/<script.*platform\/api\/index.js.*<\/script>/);
                                    if (platformApiMatched) {
                                        const platformApi = platformApiMatched.pop();
                                        txt = txt.replace(platformApi, `${platformApi.replace('api', 'api-min').replace(/ *ignore/, '')}\n  ${platformApi}`);
                                    }
                                }
                                // if (/data-name="standard_template"/.test(txt) && !/<script.*platform\/base-min\/index.js.*<\/script>/.test(txt)) {
                                //     const platformApiMatched = txt.match(/<script.*platform\/base\/index.js.*<\/script>/);
                                //     if (platformApiMatched) {
                                //         const platformApi = platformApiMatched.pop();
                                //         txt = txt.replace(platformApi, `${platformApi.replace('base', 'base-min').replace(/ *ignore/, '')}\n  ${platformApi}`);
                                //     }
                                // }
                                // if (/data-name="standard_template"/.test(txt) && !/<script.*platform\/components-min\/index.js.*<\/script>/.test(txt)) {
                                //     const platformApiMatched = txt.match(/<script.*platform\/components\/index.js.*<\/script>/);
                                //     if (platformApiMatched) {
                                //         const platformApi = platformApiMatched.pop();
                                //         txt = txt.replace(platformApi, `${platformApi.replace('components', 'components-min').replace(/ *ignore/, '')}\n  ${platformApi}`);
                                //     }
                                // }
                                if (/data-name="standard_template"/.test(txt) && !/<script.*platform\/nc-lightapp-front-min\/index.js.*<\/script>/.test(txt)) {
                                    const platformApiMatched = txt.match(/<script.*platform\/nc-lightapp-front.js.*<\/script>/);
                                    if (platformApiMatched) {
                                        const platformApi = platformApiMatched.pop();
                                        txt = txt.replace(platformApi, `${platformApi.replace('nc-lightapp-front.js', 'nc-lightapp-front-min/index.js').replace(/ *ignore/, '')}\n  ${platformApi}`);
                                    }
                                }
                                resolve({
                                    async text() {
                                        return txt;
                                    }
                                })
                            });
                        })
                    })
                }

                if (/fleehijack=true/.test(url)) {
                    const scriptDom = document.createElement('script');
                    scriptDom.src = url;
                    document.body.appendChild(scriptDom);
                    return new Promise(resolve => {
                        resolve({
                            async text() {
                                return '';
                            }
                        })
                    })
                }
            
                return window.fetch(url, ...args);
            },
            excludeAssetFilter: (assetUrl) => { // 指定部分特殊的动态加载的微应用资源（css/js) 不被 qiankun 劫持处理
                // 慎用，如果不被乾坤处理，动态加载的js将挂载在主应用window，并非子应用代理之后的window
                // 智能分析sdk内部有获取指定script标签src的逻辑，不能被乾坤劫持，否则获取不到
                // 支持部分资源逃离劫持
                return /fleehijack=true/.test(assetUrl) || /\/iuap-data-analytic*.+\/sdk\/sdk\.js*.+/.test(assetUrl);
            },
            // $$cacheLifecycleByAppName: true
        });
        qiankunApp.mountPromise.then(() => {
            // console.log('微应用加载完成', window.proxy);
            callback && callback();
            this.setMicroTheme(theme.type);
        });
        this.setState({
            qiankunApp
        })
    }

    setMicroTheme = (themeType) => {
        // console.log('set-micro-theme');
        const { app } = this.state;
        if (themeType === 'black') {
            if (isNotDealDark(this.appInfo)) { // 不适配暗黑
                window.setVarsByThemeName('initial', null, { selector: app.selector });
                themeType = 'default';
            }
        } else {
            this.microAppRef.removeAttribute('style');
        }
        setThemeClassName && setThemeClassName(this.microAppRef.querySelector(`[data-name=${app.name}]`), themeType);
    }

    qiankunUnmountApp() {
        this.props.onAppUnload();
        if (this.registerEvents) {
            const unloadEvents = this.registerEvents['unload'];
            unloadEvents && unloadEvents.forEach(c => c());
        }
        this.state.qiankunApp.unmount().then(() => {
            // 卸载之后需要置空一些数据
            this.registerEvents = null;
        });
    }

    // 刷新，供组件使用者调用
    refresh(beforeCb, afterCb) {
        this.props.canUnload(() => {
            beforeCb();
            this.qiankunUnmountApp();
            this.setState({
                app: this.getAppState()
            }, () => {
                this.qiankunLoadApp(afterCb);
            })
        })
    }

    getAppState = () => {
        const { hash } = this.props;
        this.appInfo = GetQuery(hash); // 节点信息
        const { ifr } = this.appInfo;
        const key = hash.split('page=').pop();
        const id = `microApp-${key}`;
        const loadTime = Date.now();
        return {
            key,
            // 这里必须全路径，不然加载不到
            entry: `${location.origin}${ifr.replace('../../../../', '/nccloud/resources/')}`,
            // 提取初始化路由
            initialEntries: [...ifr.match(new RegExp('(?<=#).*'))],
            id,
            selector: `#${id}`,
            // 乾坤内部逻辑唯一值是name + dom路径
            // 如果关闭页签再打开，若页签位置没变化，则dom路径没变，就会直接走mount，不会走bootstrap初始化
            // 针对于我们的场景，每次打开都必须是一个新的实例，加时间戳区分
            name: `${id}-${loadTime}`
        }
    }

    async checkClosable() {
        if (this.registerEvents) {
            const unloadEvents = this.registerEvents['beforeunload'];
            if (unloadEvents) {
                for (let i = 0; i < unloadEvents.length; i++) {
                    const closeResult = await unloadEvents[i]();
                    if (!checkWindowClosable(closeResult)) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    render() {
        const { app } = this.state;
        return <div
            ref={ref => this.microAppRef = ref}
            id={app.id}
            className="microApp-container"
            data-qiankun={app.name}
        />;
    }
}

export default connect(
    state => {
        return {
            theme: state.appData.theme
        };
    },
    {},
    null,
    { forwardRef: true },
)(MicroApp)